import { BookmarkPage, Enum_Bookmark_Category, Podcast } from '@edwin-group/people-graphql';
import { useBookmark } from '../../hooks/useBookmark';
import { BookmarkListCard } from '../shared/BookmarkListCard';
import { buildBookmarkFilters } from '../../utils/buildBookmarkFilters';
import { formatTitle } from '../../utils/formatTitle';
import { useMemo } from 'react';
import BookmarkButton from '@/components/Bookmark/BookmarkButton';
import PodcastCard from '@/pages/podcast/shared/components/podcast-card';

interface ExtendedBookmarkPage extends BookmarkPage {
  removeFromBookmarksText?: string;
}

interface PodcastBookmarkListCardProps {
  category: Enum_Bookmark_Category;
  page: BookmarkPage;
}

export default function PodcastBookmarkListCard({ category, page }: PodcastBookmarkListCardProps) {
  const filters = buildBookmarkFilters({ category });
  const { data, refetch } = useBookmark<Podcast>(filters);
  const extendedPage = page as ExtendedBookmarkPage;
  const removeLabel = extendedPage?.removeFromBookmarksText || 'Remove from bookmarks';

  return (
    <BookmarkListCard
      title={formatTitle(category)}
      data={data || []}
      page={page}
      showDivider={false}
      singleColumn
      renderCard={(podcast: Podcast) => (
        <PodcastBookmarkCard podcast={podcast} onRemoveFromBookmark={refetch} removeLabel={removeLabel} />
      )}
    />
  );
}

export interface PodcastBookmarkCardProps {
  podcast: Podcast;
  onRemoveFromBookmark?: () => void;
  removeLabel?: string;
}

export function PodcastBookmarkCard({ podcast, onRemoveFromBookmark, removeLabel }: PodcastBookmarkCardProps) {
  const bookmarkAction = useMemo(
    () => (
      <BookmarkButton
        relationId={podcast.documentId || ''}
        metadata={podcast}
        typeId={podcast.documentId || ''}
        category={'PODCAST' as Enum_Bookmark_Category}
        onRemoveFromBookmark={onRemoveFromBookmark}
        variant="outline"
        removeLabel={removeLabel}
      />
    ),
    [podcast, onRemoveFromBookmark, removeLabel],
  );

  return (
    <PodcastCard
      podcast={podcast}
      watchButtonLabel={null}
      watchAgainButtonLabel={null}
      renderBookmarkAction={bookmarkAction}
    />
  );
}
